export default "__VITE_ASSET__Bs6RWjGy__"